import React from 'react';

import Checkbox from "@mui/material/Checkbox";
import {styled} from "@mui/material/styles";

import {black500, grey50, grey500} from "assets/jss/main";

const CheckboxIcon = styled('span')({
    width: '16px',
    height: '16px',
    boxSizing: 'border-box',
    borderRadius: '4px',
    backgroundColor: grey50,
    border: `1px solid ${black500}`
});

const CheckboxCheckedIcon = styled(CheckboxIcon)({
    backgroundColor: black500,
    '&:before': {
        display: 'block',
        width: '14px',
        height: '14px',
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""'
    }
});

const StyledCheckbox = styled(Checkbox)({
    padding: 'unset',
    'input:disabled ~ span': {
        background: grey500,
        borderColor: grey500
    }
});

/**
 * Holds the checkbox's 16px when a given row may not show one (eikow products) while the
 * header always does. Without it those rows start 24px (16 + the 8px gap) to the left of
 * the column label, and the first column visibly loses its alignment from row to row.
 */
export const ListingCheckboxPlaceholder = styled('div')({
    width: '16px',
    flexShrink: 0
});

function ListingCheckbox(props) {
    return (
        <StyledCheckbox
            icon={<CheckboxIcon/>}
            checkedIcon={<CheckboxCheckedIcon/>}
            {...props}
        />
    );
}

export default ListingCheckbox;
